import React from "react";
import FilterSubmitButton from "./filter-submit-button";
import YearBuildField from "./year-build-field";
import PortfolioField from "./portfolio-field";
import OwnerOccupiedField from "./owner-occupied-field";
import UpgradeOverlay from "../../../common/UpgradeOverlay";
import { upgradeMessage, userIsRestrictedFromPortfolio } from "../../../../hooks/useCommercialAccess";
import { useSelector } from "react-redux";

export default function RecommendedFiltersTab({
  setOpenDropdown,
  openDropdown,
  register,
  watch,
  setValue,
  filterData,
}) {
  const memData = useSelector((state) => state.fetchSiteSettings?.memData);
  const isPortfolioRestricted = userIsRestrictedFromPortfolio(memData);

  return (
    <>
      <div className="col">
        <div
          className="filter_btn site_btn blank yellow_blank"
          onClick={() =>
            setOpenDropdown(
              openDropdown === "recommended" ? null : "recommended"
            )
          }
        >
          Recommended
        </div>
        <div
          className={
            openDropdown === "recommended" ? "drop_cnt active" : "drop_cnt"
          }
        >
          <div className="half_flex_outer">
            <YearBuildField
              register={register}
              filterData={filterData}
              setValue={setValue}
              watch={watch}
              fieldNamePrefix="recommend"
            />
            <PortfolioField
              register={register}
              fieldNamePrefix="recommend"
              watch={watch}
              setValue={setValue}
              filterData={filterData}
            />
            <div className="form_blk lbl_btn_blk">
              <OwnerOccupiedField
                register={register}
                filterData={filterData}
                setValue={setValue}
                watch={watch}
                fieldNamePrefix="recommend"
              />
              <div className="lbl_btn">
                <input
                  type="checkbox"
                  name="recommended_owner_property_sq_ft"
                  id="recommended_owner_property_sq_ft"
                  value="recommended_owner_property_sq_ft"
                  {...register("recommended_owner_property_sq_ft")}
                />

                <label
                  htmlFor="recommended_owner_property_sq_ft"
                  className="dim_dark_text f_s_15"
                >
                  Property over 5,000 square feet
                </label>
              </div>
              <div
                className="lbl_btn"
                style={isPortfolioRestricted ? { position: "relative" } : undefined}
              >
                <input
                  type="checkbox"
                  name="recommended_owner_portfolio"
                  id="recommended_owner_portfolio"
                  value="recommended_owner_portfolio"
                  disabled={isPortfolioRestricted}
                  {...register("recommended_owner_portfolio")}
                />

                <label
                  htmlFor="recommended_owner_portfolio"
                  className="dim_dark_text f_s_15"
                >
                  Portfolio with over 5 properties
                </label>

                {isPortfolioRestricted && (
                  <UpgradeOverlay
                    title="Investor Portfolio"
                    message={upgradeMessage(memData, "for access", "Investor Portfolio is not included on your plan.")}
                    variant="inline"
                    blur={2}
                    testId="portfolio-upgrade-overlay"
                  />
                )}
              </div>
            </div>
            <FilterSubmitButton
              clearStep="recommended"
              setValue={setValue}
              filterData={filterData}
            />
          </div>
        </div>
      </div>
    </>
  );
}
